import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-secondary-300",
  "use": "check-secondary-300-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-secondary-300\">\n    <path d=\"M4.3999 7.92097L7.22154 10.3996L11.5999 5.59961\" stroke=\"#026288\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol